<template>
    <section class="step__main">
        <slot name="header"></slot>

        <section class="step__description">
            <span>
                Gostaria de permanecer na unidade atual ou escolher uma diferente? 
            </span>

            <section class="step__details">
                <strong>{{ userData.unity_name}}</strong>
                <hr>
                <small>{{ userData.profile }}</small>
            </section>
        </section>

        <section class="step__actions">
            <v-btn
                data-test="continueInCurrentDataButton"
                class="btn__default"
                color="success"
                height="40px"
                depressed
                block
                @click="continueInCurrentData"
            >
            {{$t('buttons.continue')}}
            </v-btn>

            <v-btn
                class="btn__default"
                height="40px"
                depressed
                block
                :disabled="disableButton"
                @click="changeCurrentData"
            >
                Trocar Perfil/Unidade
            </v-btn>
        </section>
    </section>
</template>

<script>
import { mapGetters,mapActions } from "vuex"; 
import LoginService from "@/service/auth/LoginService"; 

    export default { 
        name: "CurrentLoginComponent",

        data() {
            return {
               disableButton: false,
            };
        }, 

        components: {

        },

        computed: {
            ...mapGetters({
                userData: "getCurrentUser",
            }),
        },

        mounted(){
            if(this.userData.linked_unit.length == 0){
                this.disableButton = true
            }
        },

        methods: {
            ...mapActions(["changeSnackbarData", "changeUserLogin", "changeUserData"]),
            changeCurrentData(){
                this.$emit("changeData")
            },

            async continueInCurrentData(){ 
                let userData = new Object
                    userData.cpf = this.userData.cpf
                    userData.password = this.userData.password
                    userData.profile_id = this.userData.profile_id
                    userData.unity_id = this.userData.unity_id 

                 try {
                    await LoginService.login(userData)
                    
                    setTimeout(() => {
                    this.$router.push({ name: "Dashboard" });
                    }, 1000);

                }catch(err) { 
                    this.changeSnackbarData([
                    true,
                    "error",
                    "Erro ao realizar login",
                    err.response?.data?.details || err.error,
                    ])
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.step__main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 45px;
  width: 100%;
  height: 100%;

  .step__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    width: 100%;
  }
}

.step__description {
    display: flex;
    flex-direction: column;
    text-align: center;
    gap: 20px;
    width: 100%;

    span {
      font-size: 16px;
    }

    .step__details {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 6px;
      padding: 16px;
      width: 100%;
      background: #eef1ed;
      box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
      border-radius: 15px;

      strong {
        font-size: 14px;
        font-weight: 600;
      }
    }

    hr{
        width: 250px;
        border: 1px solid rgb(22, 94, 37);
    }
  }
</style>